import qs from 'qs';
import { useMemo } from 'react';

import { LanguageCodes } from '@helpers/constants';

export const getQueryParams = (search: string) => {
  search = search.replace('?', '');
  return qs.parse(search);
};

/**
 * @description Returns result of matching pathname check
 * @param {Array} nodes - query data for form section
 * @param {Object} location - object containing current pathname
 */
export const findMatchingNodePath = (nodes: [], location: { pathname: string }) => {
  if (location) {
    const { pathname } = location;
    const matchingNode = useMemo(() => nodes.find(({ path: url }: { path: string }) => `${pathname}/`.includes(url)), [
      nodes,
      pathname,
    ]);
    return matchingNode ? matchingNode : nodes.find(({ path: url }: { path: string }) => pathname.includes(url));
  }
  return {};
};

/**
 * @description Returns true/false if object is empty
 * @param {Object} checkObject - object to check for empty
 */
export const isNotEmptyObject = (checkObject: {}) => {
  for (const key in checkObject) {
    if (checkObject.hasOwnProperty(key)) {
      return true;
    }
  }
  return false;
};

/**
 * @description Returns array of dropdown options
 * @param {Array} arrayToMap - array containing current dropdown target, dropdown options
 * - offset optionIndex to start at 1 to align with <FormSelect />
 */
export const getDropDownOptions = (arrayToMap: any[]) => {
  return arrayToMap.map((arrayOption, optionIndex) => {
    return { value: optionIndex + 1, label: arrayOption };
  });
};
/**
 * @description format config to have value and label for dropdown options to send to nora
 * @param {Object} config - object containing keys and values
 * @returns {Array} option values containing value and label to populate dropdown
 */
export const getNoraFormDropdownOptions = (config: { options: [] }) => {
  const { options } = config;
  return options.map((option) => {
    const { key: value, value: label }: { key: string; value: string } = option;
    return { value, label };
  });
};
/**
 * @description Returns matching string type language code
 * @param {Number} languageCode - language code of type int
 * - adjust languageCode to account for zero index in array
 */
export const getLanguageType = (languageCode: number) => {
  return LanguageCodes[languageCode - 1];
};
/**
 * @description Checks key is exists in object or not
 * @param {Object} obj - any object
 * @param {String} key - key name that need to check in object
 * - adjust languageCode to account for zero index in array
 */

interface ErrorObject {
  touched: object;
  errors: object;
}

export const checkKeyIsExists = (obj: ErrorObject, key: string | number) => {
  return obj.errors.hasOwnProperty(key) && obj.touched.hasOwnProperty(key);
};

export const getQueryStringParamVal = (queryString = '', key: any) => {
  return new URLSearchParams(queryString).get(key);
};
